import angular from 'angular';
import {PriorityRulesController} from './priority-rules.controller.js';
import {PriorityRuleEditionController} from './priority-rule-edition.controller';
import {PriorityRulesService} from './priority-rules.service.js';



angular
  .module('parameters.priority-rules', [])
  .controller('PriorityRulesController', PriorityRulesController)
  .controller('PriorityRuleEditionController', PriorityRuleEditionController)
  .factory('PriorityRulesFactory', PriorityRulesService.PriorityRulesFactory)
;
